import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PromotionDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class PromotionsService {
  constructor(private httpService: HttpService) {}

  public getPromotions(filterData: object): Observable<PromotionDto> {
    return this.httpService.postHttp<PromotionDto>(
      Constants.ServiceConstants.PROMOTIONS,
      filterData
    );
  }
}
